<template>
    <div id="important-message" class="important-message-text">
        <div v-for="alert in alertTemplates"><component v-bind:is="{template: alert}"/></div>
    </div>
</template>
<script>
    export default {
        name: 'important-message',
        data: function () {
            return {
                alertTemplates: [],
            }
        },
        methods: {
            getMessage: function () {
                const alerts = [];
                axios.post('/notification/getAlert')
                    .then(data => {
                        alerts.push(...data.data.notifications);
                        this.alertTemplates = alerts;
                    })
                    .catch(err => console.log('err', err));
                axios.post('/notification/getAlertAnyway')
                    .then(data => {
                        alerts.push(...data.data.notifications);
                        this.alertTemplates = alerts;
                    })
                    .catch(err => console.log('err', err));
            },
        },
        mounted() {
            this.getMessage();
            setInterval(() => {
                this.getMessage();
            }, 300000);
        }
    }
</script>
